<template>
    <div class="searchResult">
        <searchHeader @searchHandleClick="searchHandleClick" :organId="organ_id"></searchHeader>
        <searchSort @handleSort="handleSort" 
                    :sortList="staticList" 
                    :totalCurrent="current"
                    @handlePages="handlePages"
        />
        <searchList :itemList="searchResultList" :t="t"></searchList>
        <comPager :totalPages="staticList" :totalCurrent="current" @handlePages="handlePages"></comPager>
    </div>
</template>

<script>
import searchHeader from "./searchHeader";
import searchList from "./searchList";
import searchSort from './searchSort.vue'
import comPager from "../comPager";
import { postDetail, postSalesCenter } from '@/api/company'
import { handleNeedLoginRes } from '@/utils/loginGuard'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "searchResult",
    props:['organId'],
    data(){
        return{
            t:0,
            pageCompanyList: {
                organCode: '',
                classCode: this.$route.query.code ? this.$route.query.code : '',
                page: this.$route.query.page ? this.$route.query.page : 1,
                page_size: 10,
                keyword: this.$route.query.keyword ? decodeURIComponent(this.$route.query.keyword) : '',
                startdate: '',
                enddate: '',
                originalEvaluation: 0,
                lastEvaluation: 0,
                is_total: 1,
                orderby: 1
            },
            searchResultList: [],
            staticList: {},
            current:  this.$route.query.page ? this.$route.query.page : 1,
            organ_id:''
        }
    },
    watch:{
        'organId':function (newValue){
            if(newValue){
                this.organ_id = newValue
            }
        }
    },
    mounted() {
        this.t = Date.now()
        const webName = this.$router.history.current.params.name;
        this.postDetail(webName);
    },
    methods:{
        postDetail(name){
            postDetail({
                web_name: name
            }).then(res => {
                this.pageCompanyList.organCode = res.data.organ_id;
                this.postSalesCenter()
                this.$store.dispatch("pageCompany/postSalesCenter", this.pageCompanyData,()=>{})
            })
        },
        // 购物车数据 暂未填充
        postSalesCenter(){
            postSalesCenter(this.pageCompanyList).then(res => {
                //PC 未登录翻第 11 页：后端返 code 10001，data 是空壳，直接跳登录
                if (handleNeedLoginRes(res)) {
                    this.searchResultList = []
                    this.staticList = {}
                    return
                }
                this.searchResultList = res.data.dataList
                this.staticList = res.data.static
            })
        },
        setClassCode(data) {
            this.pageCompanyList.classCode = data;
            this.postSalesCenter();
        },
        // 头部搜索栏点击
        searchHandleClick(item) {
            if(item.startdate) {
                this.pageCompanyList.startdate = item.startdate + '-01-01'
                this.pageCompanyList.enddate = item.startdate + '-12-31'
                this.pageCompanyList.keyword = item.keyword
                this.pageCompanyList.originalEvaluation = item.originalEvaluation
                this.pageCompanyList.lastEvaluation = item.lastEvaluation
                this.pageCompanyList.specialCode = item.specialCode
            } else {
                this.pageCompanyList.keyword = item.keyword
                this.pageCompanyList.originalEvaluation = item.originalEvaluation
                this.pageCompanyList.lastEvaluation = item.lastEvaluation
                this.pageCompanyList.specialCode = item.specialCode
            }
            this.postSalesCenter();
        },
        // 点击分页触发
        handlePages(page) {
            this.$router.push({
                query: {
                    code: this.$route.query.code,
                    page
                }
            })
            this.postSalesCenter();
        },
        // 点击排序
        handleSort(item) {
            this.pageCompanyList.orderby = item
            this.postSalesCenter();
        }
    },
    components:{
        searchHeader,
        searchList,
        comPager,
        searchSort
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";

</style>